<script setup>
import UpdateOpenAIForm from "./Partials/UpdateOpenAIForm.vue";
import UpdateStabilityAIForm from "./Partials/UpdateStabilityAIForm.vue";
import UpdateUnsplashForm from "./Partials/UpdateUnsplashForm.vue";
import UpdateHaloscanForm from "./Partials/UpdateHaloscanForm.vue";
import UpdatePexelsForm from "./Partials/UpdatePexelsForm.vue";
import UpdateMistralForm from "./Partials/UpdateMistralForm.vue";
import UpdateXAIForm from "./Partials/UpdateXAIForm.vue";
import UpdateGroqForm from "./Partials/UpdateGroqForm.vue";
import UpdateAnthropicForm from "./Partials/UpdateAnthropicForm.vue";
import { useI18n } from "vue-i18n";
import { useForm } from "@/form";
import UpdatePixabayForm from "./Partials/UpdatePixabayForm.vue";
import UpdateIdeogramForm from "./Partials/UpdateIdeogramForm.vue";
import UpdateFluxForm from "./Partials/UpdateFluxForm.vue";
import UpdateDeepSeekForm from "./Partials/UpdateDeepSeekForm.vue";
import UpdateGeminiForm from "./Partials/UpdateGeminiForm.vue";

const { t: __ } = useI18n();

const settings = await useForm().post("settings_api_index");
</script>

<template>
    <div class="px-4 py-16 lg:px-8 sm:px-6">
        <div class="mx-auto max-w-3xl">
            <h3 class="text-4xl font-semibold leading-tight text-center text-gray-900 dark:text-white">
                {{ __("Paramétrez vos Services API") }}
            </h3>
        </div>
        <div class="mt-16 space-y-6">
            <div>
                <div class="space-y-1">
                    <h2 class="text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">{{ __("Modèles de texte") }}</h2>
                    <p class="text-sm text-gray-600 dark:text-gray-400">
                        {{ __("Ajoutez les clés API pour les modèles de texte que vous souhaitez utiliser.") }}
                    </p>
                </div>
                <div class="mx-auto grid gap-4 mt-6 2xl:grid-cols-5 lg:grid-cols-3 sm:grid-cols-2">
                    <UpdateOpenAIForm :settings="settings.openai" />
                    <UpdateMistralForm :settings="settings.mistral_ai" />
                    <UpdateAnthropicForm :settings="settings.anthropic" />
                    <UpdateXAIForm :settings="settings.x_ai" />
                    <UpdateGeminiForm :settings="settings.gemini" />
                    <UpdateDeepSeekForm :settings="settings.deepseek" />
                    <UpdateGroqForm :settings="settings.groq" />
                </div>
            </div>

            <div>
                <div class="space-y-1">
                    <h2 class="text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">{{ __("Modèles d'images") }}</h2>
                    <p class="text-sm text-gray-600 dark:text-gray-400">
                        {{ __("Ajoutez les clés API pour les modèles d'images que vous souhaitez utiliser.") }}
                    </p>
                </div>
                <div class="mx-auto grid gap-4 mt-6 2xl:grid-cols-5 lg:grid-cols-3 sm:grid-cols-2">
                    <UpdateStabilityAIForm :settings="settings.stability_ai" />
                    <UpdateFluxForm :settings="settings.flux" />
                    <UpdateIdeogramForm :settings="settings.ideogram" />
                    <UpdateUnsplashForm :settings="settings.unsplash" />
                    <UpdatePexelsForm :settings="settings.pexels" />
                    <UpdatePixabayForm :settings="settings.pixabay" />
                </div>
            </div>

            <div>
                <div class="space-y-1">
                    <h2 class="text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">{{ __("Autres") }}</h2>
                </div>
                <div class="mx-auto grid gap-4 mt-6 2xl:grid-cols-5 lg:grid-cols-3 sm:grid-cols-2">
                    <UpdateHaloscanForm :settings="settings.haloscan" />
                </div>
            </div>
        </div>
    </div>
</template>
